export default function HowIsItUsed() {
    return {
        title: 'How is it used',
        paragraphs: [
            '<div>LTC insurance may be utilized as a protection tool for clients concerned about helping to cover the potential high cost of long-term care for their future selves or family members.<div>',
        ]
    }
}


// WEBPACK FOOTER //
// ./src/components/Common/data/products/traditional-long-term-care/HowIsItUsedData.js